// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"07ce2a10","565":"40ad7885","971":"70bef6ca"}[chunkId] + ".chunk.js";
};